import { createRequestTypes } from '../utils';

export const PRODUCT_TR_LIST = createRequestTypes('productTR/PRODUCT_TR_LIST');
export const SAVE_PRODUCT_TRs = createRequestTypes('productTR/SAVE_PRODUCT_TRs');

